import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { styled } from '@mui/system';
import clsx from 'clsx';

interface IProps {
  title?: string | JSX.Element;
  content: string | JSX.Element;
  open: boolean;
  getContainer?: () => Element;
  onClose?: () => void;
  type?: 'warning' | 'error' | 'attention' | 'success' | 'info';
  shadow?: boolean;
  white?: boolean;
  className?: string;
  closeable?: boolean;
  ref?: any;
}

const AlertRoot = styled('div')`
  display: flex !important;
  align-items: center;
`;

export const Alert = (props: IProps) => {
  const alertType = props.type || 'info';
  const [open, setOpen] = useState(props.open);
  const rootCls = clsx({
    'c-alert sm:flex-col': true,
    [`c-alert--${alertType}`]: true,
    'c-alert--float': props.shadow,
    'c-alert--white': props.white ?? true,
    [props.className]: !!props.className,
  });

  const onClose = () => {
    setOpen(false);
    props.onClose?.();
  };

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const icon = {
    warning: 'icon-24-alert-bold text-warning',
    error: 'icon-24-warning-bold text-error',
    attention: 'icon-24-alert-bold text-warning',
    success: 'icon-24-success-bold text-success',
    info: 'icon-24-info-bold text-info',
  };

  let alert = (
    <AlertRoot className={rootCls}>
      <span className={`text-base float-left pr-1 font-bold flex items-center self-start`}>
        <i className={`${icon[alertType]} mr-4`} />
        {props.title}
      </span>
      <span className="c-alert__desc flex-1 sm:self-start">{props.content}</span>
      {props.closeable !== false && (
        <span
          className="sm:absolute top-3 right-2 icon-16-close-mono self-start cursor-pointer"
          onClick={onClose}
        ></span>
      )}
    </AlertRoot>
  );
  if (props.getContainer) {
    alert = createPortal(alert, props.getContainer());
  }
  return open && alert;
};
